import {
    getProduct,
    listSubscriptionItems,
    listSubscriptionItemsByPrice
} from './queries';

import {GraphQLQuery,} from '@aws-amplify/api';
import {
    CreateSubscriptionItem,
    DeleteSubscriptionItem,
    GetSubscriptionItem,
    ListSubscriptionItems,
    ListSubscriptionItemsByPrice,
    SubscriptionItem,
    UpdateSubscriptionItem
} from "../types.ts";
import { billingApiClient } from "../../billing-api-integration";
import {
    createSubscriptionItem,
    deleteSubscriptionItem,
    updateSubscriptionItem
} from "./mutations.ts";
import {ListRecordsQuery} from "../../../types";


const client = billingApiClient;


export const fetchRecords = async (subscriptionId: string, query: ListRecordsQuery) => {
    const response = await client.graphql<GraphQLQuery<ListSubscriptionItems>>({
                                                                                   query: listSubscriptionItems,
                                                                                   variables: {
                                                                                       subscriptionId,
                                                                                       ...query
                                                                                   },
                                                                               });
    return {
        items: response.data?.listSubscriptionItems.items,
        nextToken: response.data?.listSubscriptionItems.nextToken
    };
};

// FNP-331: cross-subscription "items by price" read. Used by the prices
// detail page Subscriptions tab. Backed by price-created-index GSI.
export const fetchRecordsByPrice = async (priceId: string, query: ListRecordsQuery) => {
    const response = await client.graphql<GraphQLQuery<ListSubscriptionItemsByPrice>>({
        query: listSubscriptionItemsByPrice,
        variables: {
            priceId,
            ...query
        },
    });
    return {
        items: response.data?.listSubscriptionItemsByPrice.items,
        nextToken: response.data?.listSubscriptionItemsByPrice.nextToken
    };
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetSubscriptionItem>>({
                                                                                 query: getProduct,
                                                                                 variables: {id: id},
                                                                             });
    return response.data?.getSubscriptionItem;
};

export const add = async (payload: object) => {
    const response = await client.graphql<GraphQLQuery<CreateSubscriptionItem>>({
                                                                                    query: createSubscriptionItem,
                                                                                    variables: {input: payload},
                                                                                });
    console.debug('in the service response', response);
    return response.data?.createSubscriptionItem;
};

export const update = async (id: string, record: SubscriptionItem) => {

    console.debug('IN UPDATE', id, record);

    delete record.created;
    delete record.updated;

    const response = await client.graphql<GraphQLQuery<UpdateSubscriptionItem>>({
                                                                                    query: (updateSubscriptionItem),
                                                                                    variables: {input: record},
                                                                                });
    return response.data?.updateSubscriptionItem;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeleteSubscriptionItem>>({
                                                                                    query: (deleteSubscriptionItem),
                                                                                    variables: {input: {id: id}},

                                                                                });
    return response.data?.deleteSubscriptionItem;
};
